(() => {
  const root = window.Shopify?.routes?.root || '/';
  let cart = null, queue = Promise.resolve();
  const money = (cents, currency) => ({amount: String(cents / 100), currencyCode: currency});
  function normalize(data) {
    const currency = data.currency || 'EUR';
    return {id: data.token, totalQuantity: data.item_count, note: data.note || '', checkoutUrl: new URL(root + 'checkout', location.origin).href,
      cost: {subtotalAmount: money(data.total_price, currency)},
      lines: {pageInfo: {hasNextPage: false}, nodes: data.items.map(item => ({
        id: item.key, quantity: item.quantity,
        attributes: Object.entries(item.properties || {}).map(([key, value]) => ({key, value: String(value)})),
        cost: {totalAmount: money(item.final_line_price, currency)},
        merchandise: {id: 'gid://shopify/ProductVariant/' + item.variant_id, image: item.image ? {url: item.image} : null,
          product: {title: item.product_title, handle: item.handle, url: item.url}, price: money(item.final_price, currency)}
      }))}};
  }
  function publish(data) {
    cart = normalize(data);
    document.querySelectorAll('[data-cart-count]').forEach(el => {el.textContent = cart.totalQuantity; el.hidden = !cart.totalQuantity;});
    document.dispatchEvent(new CustomEvent('watchcartchange', {detail: {cart, warnings: []}}));
    return cart;
  }
  async function request(path, data) {
    const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(root + path, {method: data ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: {'Accept': 'application/json', ...(data ? {'Content-Type': 'application/json'} : {})},
        ...(data ? {body: JSON.stringify(data)} : {}), signal: controller.signal});
      const result = await response.json();
      if (!response.ok) {
        if (response.status === 422) throw new Error('Die gewünschte Auswahl oder Menge ist derzeit nicht verfügbar.');
        throw new Error('Die Verbindung zum Shop ist gerade unterbrochen. Bitte versuche es erneut.');
      }
      return result;
    } catch (error) {
      if (error.name === 'AbortError' || error instanceof TypeError) throw new Error('Die Verbindung zum Shop ist gerade unterbrochen. Bitte versuche es erneut.');
      throw error;
    } finally {clearTimeout(timeout);}
  }
  const read = async () => publish(await request('cart.js'));
  function serial(work) {
    const next = queue.catch(() => {}).then(() => navigator.locks ? navigator.locks.request('kurdistana-native-cart', work) : work());
    queue = next; return next;
  }
  async function add(key, finishName, dial) {
    return serial(async () => {
      const model = window.WatchCatalogue[key], finish = model?.finishes.find(item => item.name === finishName);
      if (!finish || (key !== 'amedspor' && !['Westliche Ziffern','Arabische Ziffern'].includes(dial))) throw new Error('Bitte wähle ein Ziffernblatt aus.');
      if (key === 'botan' && dial === 'Westliche Ziffern') throw new Error('Westliche Ziffern sind bei Botan derzeit ausverkauft. Bitte wähle arabische Ziffern.');
      const properties = {Farbe: finish.name};
      if (key !== 'amedspor') properties.Ziffernblatt = dial;
      await request('cart/add.js', {items: [{id: Number(finish.variant), quantity: 1, properties}]});
      return read();
    });
  }
  const update = (id, quantity) => serial(async () => {
    if (!Number.isInteger(quantity) || quantity < 0 || quantity > 99) throw new Error('Bitte wähle eine Menge zwischen 1 und 99.');
    return publish(await request('cart/change.js', {id, quantity}));
  });
  const note = value => serial(async () => publish(await request('cart/update.js', {note: value.slice(0, 1000)})));
  const refresh = () => serial(read);
  const product = async handle => {
    const data = await request('products/' + encodeURIComponent(handle) + '.js');
    const currency = window.Shopify?.currency?.active || window.KM.currency || 'EUR';
    return {id: 'gid://shopify/Product/' + data.id, variants: {nodes: data.variants.map(variant => ({
      id: 'gid://shopify/ProductVariant/' + variant.id, availableForSale: variant.available,
      price: money(variant.price, currency)
    }))}};
  };
  window.WatchStore = {add, update, note, refresh, product, get cart() {return cart;},
    money: value => new Intl.NumberFormat(document.documentElement.lang === 'ku' ? 'de-DE' : document.documentElement.lang,
      {style: 'currency', currency: value.currencyCode}).format(Number(value.amount))};
  refresh().catch(() => {});
  addEventListener('pageshow', event => {if (event.persisted) refresh().catch(() => {});});
  document.addEventListener('visibilitychange', () => {if (!document.hidden) refresh().catch(() => {});});
})();
